export default __webpack_public_path__ + "static/media/crop-height.54ebc290.png";